import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE, Locale, SUPPORTED_LANGUAGES } from "./constants";
import { formatCurrency, formatDate, formatNumber } from "../utils";

// Initialize i18next
i18next.use(initReactI18next).init({
	lng: DEFAULT_LANGUAGE, // Armenian — the locale served at the root
	fallbackLng: FALLBACK_LANGUAGE, // English — the source language the copy is authored in
	supportedLngs: [...SUPPORTED_LANGUAGES],

	// No resources up front. The page's slice is injected at render time by
	// I18nProvider from `pageContext.translations`, so the client only ever holds
	// the active language and the areas the current page actually uses.
	resources: {},

	// Namespace configuration
	ns: ["common"],
	defaultNS: "common",

	// React configuration
	react: {
		useSuspense: false,
		bindI18n: "languageChanged",
		bindI18nStore: "added",
	},

	// Interpolation configuration
	interpolation: {
		escapeValue: false,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		format: (value: any, format?: string, lng?: string) => {
			const locale = lng as Locale;
			if (format === "currency") {
				return formatCurrency(value, locale || Locale.EN);
			}
			if (format === "date") {
				return formatDate(value, locale || Locale.EN);
			}
			if (format === "number") {
				return formatNumber(value, locale || Locale.EN);
			}
			return value as string;
		},
	},

	// Pluralization
	pluralSeparator: "_",

	// Development
	debug: process.env.NODE_ENV === "development",

	// Performance
	saveMissing: process.env.NODE_ENV === "development",
	missingKeyHandler: (lng, ns, key) => {
		if (process.env.NODE_ENV === "development") {
			console.warn(`Missing translation: ${lng}.${ns}.${key}`);
		}
	},
});

export { i18next as i18n };
